var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"py-0",attrs:{"subheader":"","two-line":""}},[_vm._l((_vm.items),function(item,index){return [_vm._t("items",null,{"item":item}),(index !== _vm.items.length - 1)?_c('v-divider',{key:index}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }